import {InsuranceCompanyCode} from '../../shared/models/insurance-company-code.enum';
import {ImageDefinition} from '../../shared/models/image-model';

export interface InsuranceCompanyConfig {
    code: InsuranceCompanyCode;
    name: string;
    logos?: InsuranceCompanyLogo[];
    addressDataCode?: string; // insurance company's code used for address data requests
    disabledInFilters?: boolean; // default - false
    disabledInOffersProgressDialog?: boolean; // default - false
    requiresGetOffer?: boolean; // default - false
}

export interface InsuranceCompanyLogo {
    role: InsuranceCompanyLogoRole;
    image: ImageDefinition;
}

export enum InsuranceCompanyLogoRole {
    DEFAULT = 'DEFAULT',
    OFFERS_PROGRESS_DIALOG = 'OFFERS_PROGRESS_DIALOG',
}
